// System
import { Box } from '@mui/system';

// Features
import { RoundsTitle } from '@Features/rounds/RoundTitle/RoundsTitle';
import { RoundsList } from '@Features/rounds/RoundsList';
import { Divider } from '@mui/material';
import { useGeneral } from '@Modal/hooks/general/useGeneral';
import { MinesRoundsTitle } from '@Features/rounds/MinesRoundTitle/MinesRoundsTitle';
import { MinesRoundsList } from '@Features/rounds/MinesRoundsList/MinesRoundList';
import { RubberDuckRoundsTitle } from '@Features/rounds/RubberDuckRoundTitle/RubberDuckRoundsTitle';
import { RubberDuckRoundsList } from '@Features/rounds/RubberDuckRoundsList/RubberDuckRoundList';

export const RoundsPage = () => {
  const { game } = useGeneral();

  const title =
    game === 1 ? <RoundsTitle /> : game === 3 ? <RubberDuckRoundsTitle /> : <MinesRoundsTitle />;
  const list =
    game === 1 ? <RoundsList /> : game === 3 ? <RubberDuckRoundsList /> : <MinesRoundsList />;

  return (
    <Box>
      <Box>
        {title}
        <Divider />
        {list}
      </Box>
    </Box>
  );
};
